export default "__VITE_ASSET__D9f766g5__"